import React from "react";
import { Box, Typography, Grid, Button, useTheme, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";

const PartsBenefits = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        background: "linear-gradient(135deg, #000000, #1a1a1a)",
        color: "#fff",
        overflow: "hidden",
        px: { xs: 2, md: 8 },
        py: { xs: 6, md: 12 },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
          background: `radial-gradient(circle at 25% 20%, rgba(255,255,255,0.08), transparent 60%),
                       radial-gradient(circle at 75% 70%, rgba(255,255,255,0.06), transparent 60%)`,
        }}
      />
      <Box
        sx={{
          content: '""',
          position: "absolute",
          top: "12%",
          left: "-6%",
          width: "200px",
          height: "200px",
          background: "rgba(255,255,255,0.1)",
          clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
          transform: "rotate(15deg)",
        }}
      />
      <Box
        sx={{
          content: '""',
          position: "absolute",
          bottom: "8%",
          right: "12%",
          width: "260px",
          height: "120px",
          background: "rgba(255,255,255,0.07)",
          borderRadius: "60% 40% 70% 30% / 50% 60% 40% 50%",
        }}
      />

      <Grid
        container
        spacing={{ xs: 8, md: 12 }}
        alignItems="center"
        justifyContent="center"
        sx={{ position: "relative", zIndex: 1 }}
      >
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                maxWidth: "520px",
                mx: "auto",
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: "1.6rem", sm: "2rem", md: "2.6rem" },
                  fontWeight: "bold",
                  mb: 3,
                  background: "linear-gradient(to right, #ff6600, #ff944d)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                ¡Regístrate y accede a beneficios únicos!
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  textAlign: "justify",
                  lineHeight: 1.9,
                  mb: 5,
                  color: "rgba(255,255,255,0.9)",
                }}
              >
                En <strong>CMSOLTEC</strong> nos especializamos en la venta de laptops,
                computadoras, repuestos, accesorios y mucho más. También ofrecemos servicios de{" "}
                <strong>
                  mantenimiento preventivo y correctivo, instalación de antivirus y recuperación de datos
                </strong>
                . Al registrarte en nuestra web, accedes a{" "}
                <strong>descuentos y atención preferencial</strong>. Garantizamos la protección de tu información en todo momento.
              </Typography>

              <Button
                component="a"
                href="/registro"
                sx={{
                  backgroundColor: "#ff781f",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                  px: 4,
                  py: 1.2,
                  alignSelf: "flex-start",
                  borderRadius: "30px",
                  boxShadow: "0 6px 12px rgba(0,0,0,0.35)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#e65100",
                  },
                }}
              >
                REGISTRARSE AHORA
              </Button>
            </Box>
          </motion.div>
        </Grid>

        <Grid item xs={12} md={6} display="flex" justifyContent="center">
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "540px",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 12px 28px rgba(0,0,0,0.35)",
              }}
            >
              <img
                src={require("../../static/media/home/register.webp")}
                alt="Registro CMSOLTEC"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: isMobile ? "200px" : "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PartsBenefits;
